var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#03144c","height":"100vh"}},[_c('div',{ref:"screens",staticClass:"screens"},[_c('nuxt')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }